import * as Yup from 'yup';

export const MODAL_VALIDATIONS = {
  salary: Yup.string(),
  // .matches(/^\d*[\.{1}\d*]\d*$/, 'Ejemplo 190 o 100.50')
};

export const ModalCreateUser_VALIDATIONS = {
  first_name: Yup.string().required('Campo requerido'),
  last_name: Yup.string().required('Campo requerido'),
  email: Yup.string()
    .required('Campo requerido')
    .email('Ingresé un Correo electrónico valido'),
  user_type: Yup.string().required('Campo requerido'),
};

export const ModalCreateNews_VALIDATIONS = {
  title: Yup.string().required('Campo requerido'),
  subtitle: Yup.string().required('Campo requerido'),
  image: Yup.mixed().test('fileSize', 'Campo requerido', (value) => {
    if (!value.length) return false; // attachment is optional
    return value[0].size <= 2000000;
  }),
};
